import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";

const RenameFile = ({ setOpenRenameFolderPopup, selected }) => {
  const {
    register,
    formState: { errors },
    setError,
    handleSubmit,
  } = useForm<any>({
    defaultValues: {
      title: selected?.title,
    },
  });

  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["file"],
  });

  const handleRenameFolder = async (values: any, setError: any) => {
    const url = `${APIS.FILE}${selected?.id}/`;
    const formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOpenRenameFolderPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div className={tw`w-72`}>
      <form
        onSubmit={handleSubmit((data) => handleRenameFolder(data, setError))}
      >
        <div>
          <TextField register={register("title")} errors={errors?.title} />
        </div>
        <div>
          <div className={tw`flex gap-x-4 items-center`}>
            <button
              type="button"
              onClick={() => setOpenRenameFolderPopup(false)}
              className={tw`bg-gray-400 w-full text-white py-2 rounded my-2 focus:outline-none`}
            >
              Cancel
            </button>
            <Button label={"Save"} isLoading={isLoading} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default RenameFile;
